import {
    RaikoButtonPrimary, RaikoButtonSecondary,
    RaikoCustomSimpleActiveDeActiveChip, RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoMultiSelectTable,
    showErrorMessage, showWarningMessage, RaikoBaseCardContainer,
    RaikoSectionContainer, RaikoGridThreeColumn, RaikoMaterialOutlinedInput, RaikoNumberInputOutlined
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RaikoStepper} from "../../../raikoComponents/raikoStepper/RaikoStepper";
import React, {useEffect, useState} from "react";
import {UserService} from "../../../serverService/userService/UserService";
import {useAuthState} from "../../../context/AuthContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import NewAccountFinalStep from "./NewAccountFinalStep";
import {useDebounce} from "@uidotdev/usehooks";

export default function NewAccount(
    {
        handleAddNewAccountToTable
    }
) {

    const [stepper, setStepper] = useState(0)
    const [steps, setSteps] = useState(["مالک حساب", "قیم حساب", "بازبینی و ثبت"]);


    const usersService = new UserService()

    let page = 0
    const size = 10

    const [users, setUsers] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [loadingState, setLoadingState] = useState(false);
    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [groupName, setGroupName] = useState("")
    const filterFullName = useDebounce(fullName, 300)
    const filterNationalCode = useDebounce(nationalCode, 300)
    const filterGroupName = useDebounce(groupName, 300)

    const [userInfo, setUserInfo] = useState([]);
    const [guardian, setGuardian] = useState([]);

    const {fundID} = useAuthState()

    useEffect(() => {
        if ([0, 1].includes(stepper)) {
            page = 0
            getUsersFromServer()
        }
    }, [stepper, filterFullName,
        filterNationalCode,
        filterGroupName]);

    function prepareItem(id, number, fullName, nationalCode, groupName, phoneNumber, enabled) {

        return {
            id,
            name: fullName,
            number,
            fullName,
            nationalCode,
            groupName,
            phoneNumber: phoneNumber ? phoneNumber : "-",
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled} چ
                activeStateTitle={"فعال"}
                deActiveStateTitle={"غیرفعال"}
            />,
        }
    }

    function getUsersFromServer() {
        setLoadingState(true)
        usersService.getUsersList(
            page,
            size,
            fundID,
            filterFullName,
            filterGroupName,
            filterNationalCode,
        ).then(response => {
            setPageCount(response.totalPage)
            setUsers([])
            response.data.map((item, index) => {
                setUsers(prev => [
                    ...prev,
                    prepareItem(
                        item.id,
                        (page * size) + index + 1,
                        item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-",
                        item.nationalCode,
                        item.groupName,
                        item.phoneNumber,
                        item.enabled
                    )
                ])
            })
        }).catch(reason => {
            showErrorMessage((detectServerErrorMessage(reason)))
        }).finally(_ => {
            setLoadingState(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getUsersFromServer()
    }

    function findUserInfo(id) {
        let info = {}
        users.map((item, index) => {
            if (item.id === id) {
                info = item
            }
        })


        return info
    }

    return (
        <RaikoGridOneColumn
            className={css`
                padding: 0 1rem 1rem 1rem;
                gap: 1.5rem;
            `}
        >
            <RaikoStepper activeStep={stepper} steps={steps} alternativeLabel={true}/>
            {
                stepper === 0 ?
                    <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                        <RaikoSectionContainer
                            title={"جستجو"}>
                            <RaikoGridThreeColumn>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام و نام خانوادگی"}
                                    value={fullName}
                                    setValue={setFullName}/>
                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    value={nationalCode}
                                    setValue={setNationalCode}/>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام گروه"}
                                    value={groupName}
                                    setValue={setGroupName}/>
                            </RaikoGridThreeColumn>

                        </RaikoSectionContainer>
                        <RaikoMultiSelectTable
                            pageCount={pageCount}
                            handleChangePagination={handleChangePagination}
                            tableData={users}
                            tableHeader={header}
                            setSelectedItems={item => {
                                if (item && item.length > 0) {
                                    const info = findUserInfo(item[0].id)
                                    setUserInfo([info])
                                } else
                                    setUserInfo([])
                            }}
                            selectedItems={userInfo}
                            isSingleSelect
                            tableHintTitle={"مالک حساب"}
                            tableLoadingState={loadingState}
                            notSelectedAnyItemAlertDescription={[]}
                            notSelectedAnyItemAlertTitle={"لطفا مالک حساب را انتخاب نمایید"}
                        />
                    </RaikoGridOneColumn> :
                    stepper === 1 ?
                        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                            <RaikoSectionContainer
                                title={"جستجو"}>
                                <RaikoGridThreeColumn>
                                    <RaikoMaterialOutlinedInput
                                        labelText={"نام و نام خانوادگی"}
                                        value={fullName}
                                        setValue={setFullName}/>
                                    <RaikoNumberInputOutlined
                                        labelText={"کد ملی"}
                                        value={nationalCode}
                                        setValue={setNationalCode}/>
                                    <RaikoMaterialOutlinedInput
                                        labelText={"نام گروه"}
                                        value={groupName}
                                        setValue={setGroupName}/>
                                </RaikoGridThreeColumn>

                            </RaikoSectionContainer>
                            <RaikoMultiSelectTable
                                pageCount={pageCount}
                                handleChangePagination={handleChangePagination}
                                tableData={users}
                                tableHeader={header}
                                setSelectedItems={item => {
                                    if (item && item.length > 0) {
                                        if (item[0].id !== userInfo[0].id) {
                                            const info = findUserInfo(item[0].id)
                                            setGuardian([info])
                                        } else {
                                            showWarningMessage("مالک حساب و قیم نمی توانند یک شخص باشند.")
                                        }
                                    } else
                                        setGuardian([])
                                }}
                                selectedItems={guardian}
                                isSingleSelect
                                tableHintTitle={"قیم حساب"}
                                tableLoadingState={loadingState}
                                notSelectedAnyItemAlertDescription={[
                                    "* قیم توانایی دسترسی کامل به این حساب را خواهد داشت",
                                    "* مالک حساب و قیم نمی توانند یکسان باشند",
                                ]}
                                notSelectedAnyItemAlertTitle={"لطفا قیم حساب را انتخاب نمایید"}
                            />
                        </RaikoGridOneColumn> :
                        <NewAccountFinalStep
                            userInfo={userInfo}
                            guardian={guardian}
                            setStepper={setStepper}
                            handleAddNewAccountToTable={handleAddNewAccountToTable}
                        />
            }

            <RaikoFlexAlignEnd
                className={
                    css`
                        position: sticky;
                        bottom: 0;
                        background: var(--color-on-surface);
                        padding: 1rem .5rem;

                    `}
            >
                {
                    stepper !== 0 && stepper !== 2 &&
                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            setStepper(prev => {
                                if (prev !== 0)
                                    return prev - 1
                                else
                                    return 0
                            })
                        }}
                    />
                }
                {
                    stepper !== 2 && <RaikoButtonPrimary
                        label={"ادامه"}
                        onClick={_ => {
                            if (stepper === 0 && userInfo.length === 0) {
                                showWarningMessage("لطفا ابتدا مالک حساب را انتخاب نمایید.")
                            } else {
                                if (stepper !== 2)
                                    setStepper(prev => prev + 1)
                            }
                        }}
                    />
                }
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "nationalCode",
        label: "کد ملی",
    },
    {
        id: "groupName",
        label: "نام گروه",
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]
